import { useEffect, useState } from 'react'

const getSecondsRemaining = (timestamp) => Math.floor((timestamp - Date.now()) / 1000)

const useCountdownTimer = (timestamp: number) => {
  const [secondsRemaining, setSecondsRemaining] = useState(getSecondsRemaining(timestamp))

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    if (secondsRemaining > 0) {
      timer = setTimeout(() => {
        setSecondsRemaining(getSecondsRemaining(timestamp))
      }, 1000)
    }

    return () => {
      clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondsRemaining])

  useEffect(() => {
    setSecondsRemaining(getSecondsRemaining(timestamp))
  }, [timestamp])

  return { secondsRemaining }
}

export default useCountdownTimer
